<template>
	<div class="pages" :style="{ height: height + 'px' }">
		<navTop></navTop>
		<div class="box">
			<div class="box-main">
				<div class="box-main-top">
					<p>Please select a star</p>
					<el-rate
						v-model="star"
						:void-color="'#00FFF0'"
						:colors="['#00FFF0', '#00FFF0', '#00FFF0']"
					></el-rate>
				</div>
				<div class="box-main-title">More evaluation</div>
				<textarea
					class="box-main-textarea"
					v-model="content"
					placeholder="Please enter the evaluation content"
				></textarea>
				<div class="box-main-btn" @click="subimt">Release evaluation</div>
			</div>
		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
export default {
	name: 'evaluate',
	components: {
		navTop
	},
	data() {
		return {
			height: '',
			star: 0,
			content: '',
			id: ''
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.height = window.innerHeight;
			this.id = this.$route.query.id;
		}
	},
	methods: {
		subimt() {
			if (this.star == 0) {
				this.$message({
					message: 'Please select a rating',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			if (this.content == '') {
				this.$message({
					message: 'Please enter the evaluation content',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			let data = {
				uid: sessionStorage.getItem('uid'),
				orderId: this.id,
				score: this.star,
				content: this.content
			};
			this.$api.appraise(data).then(res => {
				console.log(res);
				if (res.result == 0) {
					this.$router.push({ path: '/success', query: { num: 4 } });
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	.box {
		padding-top: 86px;
		box-sizing: border-box;
		.box-main {
			width: 100%;
			height: 631px;
			border-radius: 38px;
			background-image: url(../../assets/cancel.png);
			background-size: 100% 100%;
			padding: 83px 200px 139px;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-between;
			.box-main-top {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				p {
					font-size: 24px;
					color: #00fff0;
					line-height: 1em;
					margin-right: 37px;
				}
        ::v-deep .el-rate {
					height: 30px;
					.el-rate__item {
						.el-rate__icon {
							margin-right: 16px;
							font-size: 30px;
						}
					}
				}
			}
			.box-main-title {
				width: 100%;
				font-size: 24px;
				color: #00fff0;
				line-height: 1em;
				text-align: center;
			}
			.box-main-textarea {
				width: 100%;
				height: 159px;
				background: rgba(35, 254, 246, 0.1);
				border: 1px solid #48ece7;
				outline: none;
				resize: none;
				padding: 17px 20px;
				box-sizing: border-box;
				font-size: 16px;
				font-weight: 400;
				color: #13fffc;
				line-height: 28px;
			}
			.box-main-textarea::-webkit-input-placeholder {
				color: #13fffc;
			}
			.box-main-btn {
				width: 100%;
				height: 60px;
				background: linear-gradient(
					90deg,
					rgba(29, 175, 170, 0.8) 0%,
					rgba(35, 254, 246, 0.8) 100%
				);
				font-size: 24px;
				font-family: Adobe Heiti Std;
				font-weight: normal;
				color: #f6f6f6;
				line-height: 60px;
				text-align: center;
			}
		}
	}
}
</style>
